import { Component } from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {BrandFaviconComponent} from '../../../../shared/components/brand-favicon/brand-favicon.component';

@Component({
  selector: 'app-link-cell',
  imports: [
    BrandFaviconComponent
  ],
  templateUrl: './link-cell.component.html',
  styleUrl: './link-cell.component.scss'
})
export class LinkCellComponent implements ICellRendererAngularComp {
    domain :string = '';
    customClass: string = '';

  agInit(params: ICellRendererParams): void {
    this.domain = params.value;
    this.customClass = params.colDef?.cellClass as string ?? '';
  }

  refresh(params: ICellRendererParams<any>): boolean {
    return false;
  }
}
